import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['addDocumentsForm', 'addDocumentsBtn', 'addDocumentsWrapper']

  connect() {
    // Initialize the add documents form in hidden state
    if (this.hasAddDocumentsWrapperTarget)
      this.addDocumentsWrapperTarget.style.display = 'none'
  }

  clearAddDocumentsForm(event) {
    if (event.detail.success) this.addDocumentsFormTarget.reset()
  }

  sort(event) {
    // Update the URL without a page reload (to add query params)
    const url = event.currentTarget.href
    window.history.pushState({}, '', url)
  }

  showAddDocumentsForm(event) {
    event.preventDefault()
    if (this.hasAddDocumentsWrapperTarget)
      $(this.addDocumentsWrapperTarget).slideToggle()
  }
}
